/* eslint-disable no-nested-ternary */
import { FunctionComponent } from 'react';
import OnlineBankAccountForm from './OnlineBankAccountForm';
import { OnlineBankAccountRequestType } from './types';
import { usePaylink } from '@/providers/Paylink.provider';

type OnlineBankAccountContainerProps = {
  isButtonEnabled: boolean;
  setIsAdditionalFormCompleted: (val: boolean) => void;
  onlineBankFormValues: (val: OnlineBankAccountRequestType) => void;
};

type FC = FunctionComponent<OnlineBankAccountContainerProps>;

const OnlineBankAccountContainer: FC = (props: OnlineBankAccountContainerProps) => {
  const { isButtonEnabled, setIsAdditionalFormCompleted, onlineBankFormValues } = props;
  const { paylink } = usePaylink();
  const initalFormValues = {
    IdentificationNumber: '',
    PhoneNumber: paylink.ReceiverPhoneNumber,
    FirstName: '',
    LastName: '',
    CompanyName: '',
  };

  const handlers = {
    saveOnlineBankAccountForm: (_values: OnlineBankAccountRequestType) => {
      onlineBankFormValues(_values);
    },
  };

  return (
    <OnlineBankAccountForm
      handlers={handlers}
      defaultValues={initalFormValues}
      isButtonEnabled={isButtonEnabled}
      setIsAdditionalFormCompleted={setIsAdditionalFormCompleted}
    />
  );
};

export default OnlineBankAccountContainer;
